import React, { createContext, useContext, useState, useEffect } from 'react';

// Проверяем наличие API_URL, чтобы избежать ошибок
const API_URL = process.env.GATSBY_AUTH_URL || '';

const AuthContext = createContext();


// Провайдер аутентификации
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [jwt, setJwt] = useState(() => localStorage.getItem("jwt") || null);

  const login = async (identifier, password) => {
    if (!API_URL) {
      console.error("GATSBY_AUTH_URL не задан");
      throw new Error("Сервер авторизации недоступен");
    }

    try {
      const response = await fetch(`${API_URL}/auth/local`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier, password }),
        credentials: 'include',
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Ошибка авторизации');

      localStorage.setItem('jwt', data.jwt);
      setJwt(data.jwt);
      setUser(data.user);

      return data;
    } catch (error) {
      console.error('Ошибка входа:', error);
      throw error;
    }
  };

    // 🔹 Новый метод для BlueSky login
  const loginBlueSky = async ({ identifier, password, pds }) => {
    if (!API_URL) throw new Error("Сервер авторизации недоступен");

    try {
      const response = await fetch(`${API_URL}/auth/bluesky`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier, password, pds }),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Ошибка входа через BlueSky');
      }

      localStorage.setItem('jwt', data.data.jwt);
      setJwt(data.data.jwt);
      setUser(data.data.user);

      return data.data;
    } catch (error) {
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem('jwt');
    setJwt(null);
    setUser(null);
  };

  useEffect(() => {
    const token = localStorage.getItem("jwt");
    if (!token) return;

    const fetchUserData = async () => {
      try {
        const response = await fetch(`${API_URL}/users/me`, {
          headers: { Authorization: `Bearer ${token}` },
          credentials: 'include',
        });

        if (!response.ok) throw new Error('Ошибка авторизации');

        const data = await response.json();
        setUser(data);
      } catch (error) {
        console.error('Ошибка загрузки пользователя:', error);
        logout();
      }
    };

    fetchUserData();
  }, []);

  return (
    <AuthContext.Provider value={{ user, jwt, login, loginBlueSky, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Хук для работы с аутентификацией
export const useAuth = () => {
  return useContext(AuthContext);
};
